module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjUiIGN5PSIyNSIgcj0iMjMuNSIgc3Ryb2tlPSIjRTI2MjE1IiBzdHJva2Utd2lkdGg9IjMiLz4KPHBhdGggZD0iTTE1IDIzLjY2MDdMMjMuNTcxNCAzMi41TDMzLjc1IDE4Ljc1IiBzdHJva2U9IiNFMjYyMTUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_credit-comp.svg
// module id = 4p5O
// module chunks = 1